var e="\nvec2 getUv1() {\n    return vertex_texCoord1;\n}\n";export{e as default};
